import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferralService } from '../../services/referral-service';
import { Referral } from '../../models/referral';
import { BackButtonComponent } from '../../../../shared/components/back-button/back-button.component';

@Component({
  selector: 'app-referral-add',
  templateUrl: './referral-add.component.html',
  styleUrls: ['./referral-add.component.scss'],
  standalone: true,
  imports: [
    MatInputModule,
    MatDividerModule,
    MatIconModule,
    FormsModule,
    RouterLink,
    MatOptionModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatCardModule,
    BackButtonComponent
  ]
})
export class ReferralAddComponent {

  adminService: ReferralService;
  router: Router;

  referral: Referral;

  constructor(
    adminService: ReferralService, 
    router: Router, 
    private snackbar: MatSnackBar
  ) {
    this.adminService = adminService;
    this.router = router;
    this.referral = new Referral("", "", [], "TRAVEL", "ACTIVE", []); 
  }

  saveReferral() {
    if (this.referral != null && this.referral != undefined) {
      this.referral.cleanUpBeforeSaving();
      this.adminService.saveReferral(this.referral).subscribe({
        next: (result) => {
          if (result) {
            this.snackbar.open('Referral created successfully', 'OK', { duration: 3000 });
            this.router.navigate(['/referrals']);
          }
        },
        error: (error) => {
          this.snackbar.open("Referral could not be created. Please try again", 'OK', { duration: 3000 });
        }
      });
    }
  }

  canSubmit(): boolean {
    return this.referral.isValid();
  }

  addAdditionalPayee() {
    this.referral.addPayee(null);
  }

  removeAdditionalPayee() {
    this.referral.removeLastPayee();
  }
}